import Image from "next/image";
import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  width?: number;
  height?: number;
}

export function Logo({ className, width = 200, height = 67 }: LogoProps) {
  return (
    <Image
      src="/logo.svg"
      alt="Topa+ CRM"
      width={width}
      height={height}
      className={cn("w-auto h-auto", className)}
      priority
    />
  );
}

